import React from 'react';
const ITEMS = [{
  text: 'USPS/project requirements vary by product, delivery setup, and installation type',
  icon: 'https://cdn.magicpatterns.com/uploads/gW4FQVn5Bp9wq3CTbELMr2/01-usps-project-requirements-icon.png'
}, {
  text: 'Match the post, finish, size, and mounting type',
  icon: 'https://cdn.magicpatterns.com/uploads/nR8YdkgpBC3RKdTvQjPmvj/02-match-post-finish-size-mounting-icon.png'
}, {
  text: 'Check house numbers and personalization',
  icon: 'https://cdn.magicpatterns.com/uploads/dyStmSj8ojw7PZza7qUEUX/03-house-numbers-personalization-icon.png'
}, {
  text: 'Verify replacement-part compatibility',
  icon: 'https://cdn.magicpatterns.com/uploads/aHy65wDVnzHN46h9fyjE6T/04-replacement-part-compatibility-icon.png'
}, {
  text: 'Ask about installation before checkout',
  icon: 'https://cdn.magicpatterns.com/uploads/msPApLUB8qD92bQyRXh25X/05-installation-before-checkout-icon.png'
}];
export function Checklist() {
  return <section className="py-16 bg-brand-card border-t border-brand-border" data-id="element-205" data-mp="3ktvsweo06yjl">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-206" data-mp="3ow0j13f8td1h">
        <h2 className="text-2xl lg:text-3xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-207" data-mp="3ovgzji9y2glc">
          Before you order, make sure the fit is right
        </h2>
        <p className="text-brand-muted max-w-2xl mx-auto mb-8" data-id="element-208" data-mp="3fuswtjq042nr">
          A quick check before checkout can prevent mismatched parts, incorrect
          mounting, delivery issues, and unnecessary returns.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-left" data-id="element-209" data-mp="35y6d4y9evhnb">
          {ITEMS.map((item, index) => <div key={index} className="bg-white p-4 rounded-lg border border-brand-border shadow-sm flex items-center gap-3" data-id="element-210" data-mp="2s7kqqzkr0pko" data-mpi={index}>
              <img src={item.icon} alt="" aria-hidden="true" className="h-9 sm:h-11 lg:h-14 w-auto object-contain shrink-0" data-id="element-211" data-mp="2i8lj9kbpyzz9" />
              <span className="text-sm font-medium text-brand-charcoal leading-snug" data-id="element-212" data-mp="242tlz8pis3yc">
                {item.text}
              </span>
            </div>)}
        </div>

        <div className="mt-10 bg-brand-goldSoft p-6 rounded-xl border border-brand-gold/30 shadow-sm text-left max-w-3xl mx-auto" data-id="element-213" data-mp="1ubp3w04js2za">
          <p className="text-sm font-medium text-brand-charcoal mb-4" data-id="element-214" data-mp="1pep05vv67cbc">
            Planning a commercial, community, or replacement mailbox project?
            Review USPS/project requirements or ask MidAtlantic before ordering.
          </p>
          <div className="flex flex-wrap gap-4 text-sm" data-id="element-215" data-mp="2d2q2uo5o3yiu">
            <a href="/uploaded/files/FederalRegistry2020.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-brand-charcoal hover:text-brand-maroon font-semibold transition-colors underline underline-offset-2" data-id="element-216" data-mp="2d159v2z04nn3">
              USPS Resources
            </a>
            <a href="/uploaded/files/USPScodeOutline2024.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-brand-charcoal hover:text-brand-maroon font-semibold transition-colors underline underline-offset-2" data-id="element-217" data-mp="38c3g8pv9xyzf">
              Postal Code Update
            </a>
            <a href="/uploaded/files/USPScodeoutlinedaddendum2024.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-brand-charcoal hover:text-brand-maroon font-semibold transition-colors underline underline-offset-2" data-id="element-218" data-mp="3n2aqiib4obp1">
              Postal Code Addendum
            </a>
            <a href="/ContactUs.html" className="text-brand-charcoal hover:text-brand-maroon font-semibold transition-colors underline underline-offset-2" data-id="element-219" data-mp="9upssjjj66ui">
              Contact MidAtlantic
            </a>
          </div>
        </div>
      </div>
    </section>;
}